"use client";

import { credientialUserSignUp } from "@/01-core/user/user";
import { Button } from "@/03-presenters/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/03-presenters/components/ui/form";
import RequiredLabel from "@/03-presenters/components/ui/required-label";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useFormStatus } from "react-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { create } from "zustand";
import { Input } from "../../ui/input";
import { EmailVerificationForm } from "./EmailVerificationForm";
import { SignUpState, credientialSignUpAction } from "./signUp.action";
import { Altcha } from "react-altcha";
type credientialSignUpStore = {
  pending: boolean;
  setPending: (pending: boolean) => void;
};
export const useCredientialSignUpStore = create<credientialSignUpStore>(set => ({
  pending: false,
  setPending: pending => set(() => ({
    pending
  }))
}));
export function CredientialSignUpForm() {
  const [signUpState, setSignUpState] = useState<SignUpState>({
    done: false
  });
  const pending = useCredientialSignUpStore(state => state.pending);
  const form = useForm<z.infer<typeof credientialUserSignUp>>({
    resolver: zodResolver(credientialUserSignUp),
    mode: "onBlur",
    defaultValues: {
      username: "",
      email: "",
      code: "",
      password: "",
      passwordConfirm: ""
    }
  });
  const {
    setError
  } = form;
  const {
    formError
  } = signUpState;
  useEffect(() => {
    if (formError) {
      formError.forEach(err => {
        setError(err.field, {
          message: err.error,
          type: "value"
        });
      });
    }
  }, [formError, setError]);
  useEffect(() => {
    if (signUpState.done) {
      window.location.reload();
    }
  }, [signUpState.done]);
  const [isClient, setIsClient] = useState(false);
  useEffect(() => setIsClient(true), []);
  return <Form {...form} data-sentry-element="Form" data-sentry-component="CredientialSignUpForm" data-sentry-source-file="SignUpForm.tsx">
      <form className="space-y-4" action={async payload => {
      const res = await credientialSignUpAction(payload);
      setSignUpState(res);
    }}>
        <FormField control={form.control} name="email" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>邮箱</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input id="email" placeholder="请输入邮箱" type="text" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignUpForm.tsx" />
        <FormField control={form.control} name="username" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>用户名</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input id="username" placeholder="请输入用户名" disabled={pending} type="text" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignUpForm.tsx" />
        <FormField control={form.control} name="password" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>密码</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input disabled={pending} id="password" placeholder="••••••••" type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignUpForm.tsx" />
        <FormField control={form.control} name="passwordConfirm" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>确认密码</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input disabled={pending} id="passwordConfirm" placeholder="••••••••" type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignUpForm.tsx" />

        <FormField control={form.control} name="code" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>邮箱验证码</RequiredLabel>
              </FormLabel>
              <div className="flex items-center gap-2">
                <FormControl>
                  <Input id="code" placeholder="请输入邮箱验证码" type="text" {...field} />
                </FormControl>
                <EmailVerificationForm setError={setError} email={form.getValues("email")} />
              </div>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignUpForm.tsx" />
        <SubmitBtn isValid={form.formState.isValid} data-sentry-element="SubmitBtn" data-sentry-source-file="SignUpForm.tsx" />
        {isClient && <Altcha
      // @ts-ignore
      strings={JSON.stringify({
        error: "抱歉，验证未通过，请再试一次",
        label: "我不是机器人",
        verified: "验证成功！",
        verifying: "验证中...",
        waitAlert: "验证中..."
      })}
      // @ts-ignore
      floating="auto" challengeurl="https://eu.altcha.org/api/v1/challenge?apiKey=ckey_01f14c8af4fb2a3b8d4cd1a6ed13" />}
      </form>
    </Form>;
}
function SubmitBtn({
  isValid
}: {
  isValid: boolean;
}) {
  const {
    pending
  } = useFormStatus();
  const setPending = useCredientialSignUpStore(state => state.setPending);
  useEffect(() => {
    setPending(pending);
  }, [pending, setPending]);
  return <Button className="gradient-btn h-10 w-full rounded-md font-medium text-white shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset]" type="submit" disabled={pending || !isValid} data-sentry-element="Button" data-sentry-component="SubmitBtn" data-sentry-source-file="SignUpForm.tsx">
      注册
      {pending ? <Loader2 className="ml-2 size-4 animate-spin" /> : <span>&rarr;</span>}
    </Button>;
}